import Vue from 'vue'
import moment from 'moment'
import Router from 'vue-router'
import store from './store'
import Homepage from './views/Homepage'
import LandingPage from './views/LandingPageMiddleware'
import ResetPassword from "./views/ResetPassword"
import Chat from "./views/Chat"
import Pricing from './views/Pricing'
// Wizard part
import Wizard from "./views/Wizard.vue"
import AddCampaign from "./components/wizard-steps/PastCampaign.vue"
import EditCampaign from "./components/wizard-steps/WizardEditCampaign.vue"
import AddCrossPromInfo from './components/wizard-steps/AddCrossPromotion.vue';
import PreviewCampaign from './components/wizard-steps/Preview.vue';
import VerifyCampaign from './components/wizard-steps/VerifyCamp.vue';
import AddUpdates from "./components/wizard-steps/AddUpdates.vue"

import Campaign from './views/Campaign'
import AdvancedSearch from "./components/AdvancedSearch/AdvancedSearch.vue"
import TermsOfUse from "./views/TermsOfUse.vue"
import PrivacyPolicy from "./views/PrivacyPolicy.vue"
import NotFound from "./views/NotFound.vue"
import PromoInfo from "./views/PromoInfo.vue"
import FAQ from "./views/FAQ.vue"
import HowItWorks from './views/HowItWorks.vue'

// Dashboard
import Dashboard from './views/Dashboard'
import Updates from './views/Dashboard/Updates'
import Requests from './views/Dashboard/Requests'
import CampaignsList from './views/Dashboard/CampaignsList'

import Information from './views/Dashboard/Membership/Information'


// Admin
import Admin from './components/Admin'
import Drafts from './components/Admin/Drafts'
import Campaigns from './components/Admin/Campaigns'
import AdminRequests from './components/Admin/Requests'
import Archives from './components/Admin/Archives'
import Referrals from './components/Admin/Referrals'

import Unsubscribe from './views/Unsubscribe'

// Ecommerce
import AddShop from './views/Ecommerce/AddShop'
import EditShop from './views/Ecommerce/EditShop'
import MyShops from './views/Ecommerce/MyShops'

import SingleShop from './views/Ecommerce/SingleShop'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'landingpage', component: LandingPage, meta: { public: true } },
        { path: '/browse', name: 'Homepage', component: Homepage },
        { path: '/resetpassword', name: 'Reset password', component: ResetPassword, meta: { public: true } },
        { path: '/mymessages', name: 'chat', component: Chat, meta: {fullPgae: true} },
        { path: '/advanced-search', name: 'Search', component: AdvancedSearch, meta: {platform: 'kickstarter'}},
        { path: '/partnerpage', redirect: '/campaigns', meta: {platform: 'kickstarter'}},
        { path: '/campaigns', name: 'Campaign Page', component: Campaign, meta: { public: true, platform: 'kickstarter'} },
        { path: '/campaigns/:campaignID', name: 'Campaign Page', component: Campaign, meta: { public: true, platform: 'kickstarter' } },
        { path: '/faq', name: 'faq', component: FAQ, meta: { public: true, platform: 'kickstarter'} },
        { path: '/termsofuse', name: 'termsofuse', component: TermsOfUse, meta: {public: true, platform: 'kickstarter'}},
        { path: '/howitworks', name: 'How it works', component: HowItWorks, meta: {platform: 'kickstarter'}},
        { path: '/privacypolicy', name: 'privacypolicy', component: PrivacyPolicy, meta: {public: true, platform: 'kickstarter'}},
        { path: '/404', name: '404', component: NotFound, meta: {public: true}},
        { path: '/pricing', name: 'pricing', component: Pricing, meta: {public: true, platform: 'kickstarter'}},
        { 
            path: '/dashboard', 
            name: 'dashboard', 
            component: Dashboard,
            meta: {platform: 'kickstarter'},
            children: [
                { path: 'requests', name: 'requests', component: Requests, meta: {platform: 'kickstarter'} },
                { path: 'updates', name: 'updates', component: Updates, meta: {platform: 'kickstarter'} },
                { path: 'campaigns/:campaignType', name: 'campaigns', component: CampaignsList, meta: {platform: 'kickstarter'}},
                { 

                    path: 'admin', 
                    component: Admin, 
                    name: 'admin',
                    children: [
                        { path: 'drafts', component: Drafts, name: 'admin-drafts', meta: {platform: 'kickstarter'}},
                        { path: 'campaigns', component: Campaigns, name: 'admin-campaigns', meta: {platform: 'kickstarter'} },
                        { path: 'requests', component: AdminRequests, name: 'admin-requests', meta: {platform: 'kickstarter'} },
                        { path: 'archives', component: Archives, name: 'admin-archives', meta: {platform: 'kickstarter'} },
                        { path: 'referrals', component: Referrals, name: 'admin-referrals', meta: {platform: 'kickstarter'}},
                    ]
                },
                { path: 'membership', name: 'membership', component: Information, meta: {platform: 'kickstarter'} }
            ]
        },
        { path: '/mydashboard', redirect: '/dashboard'},
        {
            path: '/wizard',
            component: Wizard,
            meta: {platform: 'kickstarter'},
            children: [
                { path: '',  component: AddCampaign, name: '',  meta: {platform: 'kickstarter'} },
                { path: 'edit-campaign',  component: EditCampaign, name: 'Edit campaign',  meta: {platform: 'kickstarter'} },
                { path: 'add-cross-prom-info', component: AddCrossPromInfo, name: 'Add crossprom info',  meta: {platform: 'kickstarter'}},
                { path: 'preview-campaign',  component: PreviewCampaign, name: 'Preview campaign',  meta: {platform: 'kickstarter'} },
                { path: 'add-updates',  component: AddUpdates, name: 'Add updates',  meta: {platform: 'kickstarter'} },
                { path: 'verify-campaign',  component: VerifyCampaign, name: 'Verify campaign',  meta: {platform: 'kickstarter'} },
            ]
        },
        {
            path: '/edit-campaign',
            component: PromoInfo
        },
        { path: '/unsubscribe', name: 'unsubscribe', component: Unsubscribe },
        // Only Ecommerce routes
        {
            path: '/add-shop',
            component: AddShop,
            name: 'add-shop',
            meta: {
                fullPgae: true,
                platform: 'ecommerce'
            }
        },
        {
            path: '/edit-shop/:shopId',
            component: EditShop,
            name: 'edit-shop',
            meta: {
                platform: 'ecommerce'
            }
        },
        {
            path: '/my-shops',
            component: MyShops,
            name: 'my-shops',
            meta: {
                platform: 'ecommerce'
            }
        },
        {
            path: '/shops',
            redirect: '/browse',
            name: 'shops',
            meta: {
                platform: 'ecommerce'
            }
        },
        {
            path: '/shops/:shopId',
            component: SingleShop,
            name: 'single-shop',
            meta: {
                platform: 'ecommerce',
                public: true
            }
        },
        { path: '*', redirect: '/404' },
    ]
})

router.beforeEach((to, from, next) => {

    if(to.meta.platform && store.state.platform !== to.meta.platform) {
        return next('/404')
    }

    store.commit('CLOSE_MODALS')
    // if (to.query.mode === 'verifyEmail') {
    //     store.commit('TOGGLE_MODAL', ['login', true])
    // }
    if(store.state.user && store.state.user.uid && store.state.platform === 'kickstarter') {
        const pendingModal = JSON.parse(localStorage.getItem('pendingModal'))
        if(!pendingModal) {
            localStorage.setItem(
                'pendingModal', JSON.stringify(
                    {
                        showedTime: Date.now()
                    }
                )
            )
            store.commit('TOGGLE_MODAL', ['pendings-modal', true])
        }
        else if(Math.abs(moment().diff(pendingModal.showedTime, 'hours')) >= 24) {
            store.commit('TOGGLE_MODAL', ['pendings-modal', true])
        }
    }
    next()
})

router.scrollBehavior = (to,from,savedPosition) => ({ x: 0, y: 0 })

export default router